export class Fornecedor {
  id: number;
  descricao: string;
  idTag: number;
  distribuidor: boolean;
  tokenDistribuidor: number;
  margemDistribuidor: number;
  sigla: string;
  verRastreio: boolean;
  enderecoFob: string;
}
